import React from 'react';
import { Box, Container } from '@mui/material'
import TopBar from './TopBar'
import BottomBar from './BottomBar'

const MainMenu = ({ isMobile }) => {
    return (
        <Box
            pt={3}
            pb={3}
            boxShadow="0 10px 14px -12px rgba(0, 0, 0, 0.45)"
            backgroundColor="background.paper"
            position={isMobile ? 'sticky' : 'static'}
            top={isMobile ? 0 : 'auto'}
            zIndex={isMobile ? 1200 : 'auto'}
        >
            <Container maxWidth={false} sx={{ maxWidth: '120rem', width: '100%', mx: 'auto' }}>
                <Box
                    gap={2}
                    display="flex"
                    flexDirection="column"
                >
                    <TopBar isMobile={isMobile} />
                    <BottomBar isMobile={isMobile} />
                </Box>

            </Container>

        </Box>
    );
};

export default MainMenu;